import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetFilter } from '../selectors/filterSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetPermission } from '../selectors/permissionSelector'

export const MOPRA_WELLSITES = ({ idToken }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AReclaimedWellsitesWellsiteSummary&token=${idToken}`

class MopraWellsites extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.hovered !== this.props.hovered) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    const id = 'MopraWellsites'
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      if (props.layerOptions.filter) {
        console.log(props.layerOptions.filter)
        map.getLayer(id) && map.setFilter(id, props.layerOptions.filter)
      }
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const {
      idToken,
      layerRendered,
      paint,
      datetime,
      uuidsSelected,
      uuidsHighlighted
    } = this.props
    const visible = layerRendered

    const jsonSource = {
      type: 'geojson',
      data: MOPRA_WELLSITES({ idToken })
    }

    if (!visible) {
      return null
    }
    // console.log(datetime, uuidsSelected, uuidsHighlighted)
    // console.log('datetime')
    // console.log(datetime)
    // console.log('selected')
    // console.log(uuidsSelected)
    // console.log('highlighted')
    // console.log(uuidsHighlighted)
    // console.log(uuidsHighlighted[0])
    // console.log(uuidsHighlighted[0] ? uuidsHighlighted : [''])
    return [
      <Source
        key={'MopraWellsitesSource'}
        id='MopraWellsites'
        tileJsonSource={jsonSource}
      />,
      <Layer
        key={'MopraWellsites'}
        type='fill'
        id='MopraWellsites'
        sourceId='MopraWellsites'
        paint={paint}
        filter={['==', 'timestamp', datetime || '']}
      />,
      <Layer
        key={'MopraWellsitesSelected'}
        type='line'
        sourceId='MopraWellsites'
        layout={{}}
        paint={{
          'line-color': 'red',
          'line-width': 2,
          'line-opacity': 0.8
        }}
        filter={['in', 'uuid'].concat(uuidsSelected)}
      />,
      <Layer
        key='MopraWellsitesHovered'
        type='line'
        sourceId='MopraWellsites'
        layout={{}}
        paint={{
          'line-color': 'blue',
          'line-width': 2,
          'line-opacity': 0.8
        }}
        filter={['in', 'uuid'].concat(uuidsHighlighted)}
      />
    ]
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getPermission = makeGetPermission()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        'MopraWellsites',
        'ReclaimedWellsites'
      ),
      paint: getPaint(state, 'MopraWellsites'),
      permission: getPermission(state, 'ReclaimedWellsites'),
      time: state.layer.times.Mopra || null,
      datetime: getDatetime(state, 'MopraWellsites') || '',
      uuidsSelected: state.object.uuidsSelected || [],
      uuidsHighlighted: state.object.uuidsHighlighted || []
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(MopraWellsites)



// WEBPACK FOOTER //
// ./src/layers/MopraWellsites.js